import { render, staticRenderFns } from "./BerserkerBarb.vue?vue&type=template&id=63d7eb4f"
import script from "./BerserkerBarb.vue?vue&type=script&lang=js"
export * from "./BerserkerBarb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports